import { render, staticRenderFns } from "./change_password_edit_form.vue?vue&type=template&id=5529e6b8&lang=pug"
import script from "./change_password_edit_form.vue?vue&type=script&lang=js"
export * from "./change_password_edit_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports